import React, { useState } from 'react'
import { Form, Spinner } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'

import UserForm from './UserForm'

import { updateUser } from '../services'
import { handleError } from '../../../helpers'
import { message } from 'antd'

export default function EditUserModal({ visible, onClose, user, reload }) {
	const { handleSubmit, register, formState: { errors } } = useForm({ defaultValues: user })
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		if(parseInt(values.document) === user.document) delete values.document
		if(values.password === '') delete values.password
		updateUser(user.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<UserForm 
						register={register}
						errors={errors}
						editable
					/>
					<Button color='primary' type="submit" disabled={loading}>
						{ loading && <Spinner animation="border" size="sm" className='mr-1' /> }
						Actualizar Registro
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}